// extracted by mini-css-extract-plugin
module.exports = {"learning":"Learning_learning__2VLgK","main":"Learning_main__3tbtn","error":"Learning_error__2kI9V","errorH1":"Learning_errorH1__1XDDj"};